import React from 'react'

export const ClockIcon = (
  color = '#007B39',
  secondaryColor = '#E1FEE6',
  width = 70,
  height = 50
) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 70 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.875" cy="16.875" r="1.875" fill={color} />
      <circle cx="65.625" cy="38.125" r="1.875" fill={color} />
      <circle cx="8.125" cy="11.875" r="0.625" fill={color} />
      <circle cx="6.25" cy="28.75" r="1.25" fill={color} />
      <circle cx="63.125" cy="45.625" r="0.625" fill={color} />
      <circle cx="68.75" cy="28.75" r="1.25" fill={color} />
      <rect x="11.25" width={50} height={50} rx={25} fill={secondaryColor} />
      <g clipPath="url(#clip0_5191_9656)">
        <path
          d="M36.25 12.5C43.1537 12.5 48.75 18.0963 48.75 25C48.75 31.9037 43.1537 37.5 36.25 37.5C29.3463 37.5 23.75 31.9037 23.75 25C23.75 18.0963 29.3463 12.5 36.25 12.5ZM36.25 15C33.5978 15 31.0543 16.0536 29.1789 17.9289C27.3036 19.8043 26.25 22.3478 26.25 25C26.25 27.6522 27.3036 30.1957 29.1789 32.0711C31.0543 33.9464 33.5978 35 36.25 35C38.9022 35 41.4457 33.9464 43.3211 32.0711C45.1964 30.1957 46.25 27.6522 46.25 25C46.25 22.3478 45.1964 19.8043 43.3211 17.9289C41.4457 16.0536 38.9022 15 36.25 15ZM36.25 17.5C36.5562 17.5 36.8517 17.6124 37.0805 17.8159C37.3093 18.0193 37.4554 18.2997 37.4913 18.6037L37.5 18.75V24.4825L40.8837 27.8663C41.1079 28.0912 41.2381 28.393 41.2478 28.7105C41.2575 29.0279 41.146 29.3371 40.9359 29.5753C40.7259 29.8136 40.4331 29.9629 40.1169 29.993C39.8008 30.0231 39.485 29.9318 39.2338 29.7375L39.1163 29.6337L35.3663 25.8837C35.172 25.6893 35.0472 25.4363 35.0112 25.1637L35 25V18.75C35 18.4185 35.1317 18.1005 35.3661 17.8661C35.6005 17.6317 35.9185 17.5 36.25 17.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5191_9656">
          <rect
            width={30}
            height={30}
            fill="white"
            transform="translate(21.25 10)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
